import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../../types/productApiTypes";
import WishlistToggleButton from "../../../../wishlist/components/common/WishlistToggleButton";
import CompareToggleButton from "../../../../compare/components/common/CompareToggleButton";
import Icon from "../../../../../../common/components/Icon/Icon";

export interface CardQuickActionsProps {
  product: TransformedProduct;
  onQuickViewClick: (productId: number) => void;
}

/**
 * Renders the desktop-only quick actions bar that appears on hover.
 */
const CardQuickActions: React.FC<CardQuickActionsProps> = ({
  product,
  onQuickViewClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="product-card__quick-actions">
      <WishlistToggleButton
        productId={product.id}
        className="product-card__action-btn"
      />

      <button
        className="product-card__action-btn"
        aria-label={t("productCard.quickViewTitle")}
        title={t("productCard.quickViewTitle")}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onQuickViewClick(product.id);
        }}
      >
        <Icon iconName="eye-filled" className="icon--filled" />
      </button>

      <CompareToggleButton
        // Use the main product ID (Parent ID for variable products) for comparison.
        productId={product.id}
        className="product-card__action-btn"
      />
    </div>
  );
};

export default CardQuickActions;
